import React, { useState, useEffect, useCallback } from 'react';
import {
  Table, Button, Space, Card, Typography, message, Row, Col, Input, Tag,
} from 'antd';
import { FileTextOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import api from '../../api/axios';

const { Title } = Typography;
const { Search } = Input;

const KiraSozlesmeListe = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/kiralik');
      const arr = Array.isArray(res.data) ? res.data : res.data.data || [];
      setData(arr);
    } catch {
      message.error('Kiralık kayıtlar yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const filtered = data.filter((item) => {
    const q = searchText.toLowerCase();
    return (
      (item.kirayaVeren || '').toLowerCase().includes(q) ||
      (item.kiralayanAdi || '').toLowerCase().includes(q) ||
      (item.ilAdi || '').toLowerCase().includes(q)
    );
  });

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: 'Kiraya Veren',
      dataIndex: 'kirayaVeren',
      key: 'kirayaVeren',
      render: (t) => <strong>{t || '-'}</strong>,
    },
    {
      title: 'Kiralayan',
      dataIndex: 'kiralayanAdi',
      key: 'kiralayanAdi',
    },
    {
      title: 'İl / İlçe',
      key: 'adres',
      render: (_, r) => `${r.ilAdi || '-'} / ${r.ilceAdi || '-'}`,
    },
    {
      title: 'Kira Tarihi',
      dataIndex: 'kiraTarihi',
      key: 'kiraTarihi',
      render: (v) => v ? dayjs(v).format('DD.MM.YYYY') : '-',
    },
    {
      title: 'Durum',
      dataIndex: 'kiralikDurum',
      key: 'kiralikDurum',
      render: (v) => {
        const map = { 'Aktif': 'green', 'Bitti': 'red', 'Beklemede': 'orange' };
        return v ? <Tag color={map[v] || 'default'}>{v}</Tag> : '-';
      },
    },
    {
      title: 'Oluşturan',
      dataIndex: 'kayitKullanici',
      key: 'kayitKullanici',
      render: (v) => v || '-',
    },
    {
      title: 'İşlem',
      key: 'action',
      fixed: 'right',
      width: 180,
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          icon={<FileTextOutlined />}
          onClick={() => navigate(`/kira-sozlesmesi/${record.id}`)}
        >
          Sözleşme Oluştur / Görüntüle
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Space>
            <FileTextOutlined style={{ fontSize: 20, color: '#1677ff' }} />
            <Title level={4} style={{ margin: 0 }}>Kira Sözleşmeleri</Title>
          </Space>
        </Col>
        <Col>
          <Search
            placeholder="Ara..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            allowClear
            style={{ width: 220 }}
          />
        </Col>
      </Row>

      <Card className="content-card" bodyStyle={{ padding: 0 }}>
        <Table
          columns={columns}
          dataSource={filtered}
          rowKey="id"
          loading={loading}
          bordered
          size="middle"
          scroll={{ x: 800 }}
          pagination={{ pageSize: 15, showTotal: (t) => `Toplam ${t} kayıt` }}
          locale={{ emptyText: 'Kiralık kayıt bulunamadı' }}
        />
      </Card>
    </div>
  );
};

export default KiraSozlesmeListe;
